import React from 'react';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import styles from './Rights.module.scss';
const Rights = () => {
  return <Box component={'section'} className={styles['container']} data-sentry-element="Box" data-sentry-component="Rights" data-sentry-source-file="Rights.tsx">
      <Typography variant={'bodyM'} data-sentry-element="Typography" data-sentry-source-file="Rights.tsx">
        تمامی حقوق این وب‌سایت متعلق به شرکت وندا رایمند شریف است
      </Typography>
    </Box>;
};
export default Rights;